import { Spinner } from 'common/Spinner/Spinner'
import Styles from './LoadingState.module.scss'

export const LoadingState = () => (
  <div className={Styles.loadingState}>
    <Spinner />
  </div>
)
